import { Button, Fade, FormControl, FormLabel, Grid, MenuItem, Modal, Select, TextField } from "@mui/material";
import "../Common/css/styles.css"
import { useEffect, useState } from "react";
import PrimaryInputField from "src/Components/InputFields";
import { Add } from "@mui/icons-material";
import { PlusOutlined } from "@ant-design/icons";
import CustomAlert from "src/Components/Alerts";
import Spinner from "src/Components/Spinner";
import { getTicketsByUserId, raiseTicket } from "src/Services/user_api";

export default function Tickets() {
    const [title, setTitle] = useState("")
    const [ticketType, setTicketType] = useState(0)
    const [description, setDescription] = useState("")
    const [alertOpen, setAlertOpen] = useState(false)
    const [alertDescription, setAlertDescription] = useState("")
    const [alertType, setAlertType] = useState<"success" | "error" | "warning">("success");
    const [isLoading, setIsLoading] = useState(false)
    const [tickets, setTickets] = useState<any[]>([])
    const [openModal, setOpenModal] = useState(false);
    const [selectedTicket, setSelectedTicket] = useState<any | null>(null);

    const userType = sessionStorage.getItem("userType") || "";

    const handleOpenModal = (ticket: any) => {
        setSelectedTicket(ticket);
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const token = sessionStorage.getItem("token");

    const showAlert = (description: string, type: "success" | "error" | "warning") => {
        setAlertDescription(description);
        setAlertType(type);
        setAlertOpen(true);
    };

    const handleClose = () => {
        setIsLoading(false)
    }

    const userId = sessionStorage.getItem("userId") || "";

    const handleGetTicketsByStudentId = async () => {
        try {
            const tickets = await getTicketsByUserId(token, userId);
            setTickets(tickets);
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        handleGetTicketsByStudentId();
    }, []);

    const onButtonClick = async () => {
        setIsLoading(true)

        const body = {
            studentId: userId,
            title: title,
            ticketType: ticketType,
            description: description,
            isAddressed: false
        }

        try {
            await raiseTicket(token, body)
            showAlert("Ticket Raised Successfully", "success");
            setTitle("")
            setTicketType(0)
            setDescription("")
            handleClose()
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        } catch (error) {
            showAlert("Failed to Raise Ticket", "error");
            handleClose()
        }
    }

    return (
        <div className="comman-outer">
            <CustomAlert
                open={alertOpen}
                onClose={() => setAlertOpen(false)}
                description={alertDescription}
                type={alertType}
                timeout={3000}
            />
            <Spinner isLoading={isLoading} />
            {userType === "STUDENT" && (
                <>
                    <div>
                        <div className="table-title-outer">
                            <div className="table-title">Raise Your Ticket</div>
                        </div>
                        <div className="space-bar"></div>

                        <div className="card-outer">
                            <Grid container spacing={2} style={{ padding: "16px" }} className="form-grid ">
                                <Grid item xs={12} md={6}>
                                    <FormLabel component="legend" sx={{ color: "#3d3d3dff", mb: 1 }}>Title</FormLabel>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        placeholder="Ticket Title"
                                        size="small"
                                        value={title}
                                        onChange={(e) => setTitle(e.target.value)}
                                        sx={{
                                            backgroundColor: "black",
                                            input: {
                                                color: "#ffffff",
                                                "::placeholder": {
                                                    color: "grey",
                                                    opacity: 1,
                                                },
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                "& fieldset": {
                                                    borderColor: "#555",
                                                },
                                                "&:hover fieldset": {
                                                    borderColor: "#aaa",
                                                },
                                                "&.Mui-focused fieldset": {
                                                    borderColor: "gray",
                                                },
                                            },
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormLabel component="legend" sx={{ color: "#3d3d3dff", mb: 1 }}>Ticket Type</FormLabel>
                                    <FormControl fullWidth>
                                        <Select
                                            value={ticketType}
                                            onChange={(e) => {
                                                setTicketType(Number(e.target.value))
                                            }}
                                            size="small"
                                            sx={{
                                                backgroundColor: "black",
                                                color: "#ffffff",
                                                "& .MuiSvgIcon-root": {
                                                    color: "#ffffff",
                                                },
                                                "& .MuiOutlinedInput-notchedOutline": {
                                                    borderColor: "#555",
                                                },
                                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                                    borderColor: "#aaa",
                                                },
                                                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                    borderColor: "gray",
                                                },
                                                "& .MuiSelect-icon": {
                                                    color: "#ffffff",
                                                }
                                            }}
                                        >
                                            <MenuItem disabled value={0}>Select a Ticket Type</MenuItem>
                                            <MenuItem value={1}>Operational Ticket</MenuItem>
                                            <MenuItem value={2}>Technical Ticket</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                    <FormLabel component="legend" sx={{ color: "#3d3d3dff", mb: 1 }}>Description</FormLabel>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        placeholder="Ticket Description"
                                        size="small"
                                        multiline
                                        rows={4}
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                        sx={{
                                            backgroundColor: "black",
                                            "& textarea": {
                                                color: "#ffffff",                // text color
                                            },
                                            "& textarea::placeholder": {
                                                color: "grey",                   // placeholder
                                                opacity: 1,
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                "& fieldset": {
                                                    borderColor: "#555",
                                                },
                                                "&:hover fieldset": {
                                                    borderColor: "#aaa",
                                                },
                                                "&.Mui-focused fieldset": {
                                                    borderColor: "gray",
                                                },
                                            },
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </div>

                        <div className="pagination-footer">
                            <div></div>

                            <Button
                                className="primary-btn"
                                variant="contained"
                                size="small"
                                disabled={title === "" || ticketType === 0 || description === ""}
                                onClick={onButtonClick}
                                startIcon={<PlusOutlined style={{ fontSize: "14px", color: "black" }} />}
                            >
                                Create Ticket
                            </Button>
                        </div>
                    </div>
                </>
            )}

            <h3 style={{ marginTop: "40px", color: "black" }}>Tickets History</h3>
            <Grid container spacing={2} style={{ marginTop: "20px", display: "flex", flexWrap: "wrap", justifyContent: "left", backgroundColor: "#5c5b5bff", padding: "20px" }}>

                {/* Ticket List can be rendered here */}
                {tickets
                    .sort((a, b) => new Date(b.lastSyncedTime).getTime() - new Date(a.lastSyncedTime).getTime())
                    .map((ticket) => (
                        <Grid
                            item
                            xs={12}
                            sm={6}
                            md={4}
                            key={ticket.id}
                            style={{ display: "flex", justifyContent: "left", flexWrap: "wrap", alignItems: "center" }}
                        >
                            <div className="ticket-card" onClick={() => handleOpenModal(ticket)} style={{ cursor: "pointer" }}>
                                <h3>{ticket.title}</h3>
                                <p>
                                    <strong>Type:</strong>{" "}
                                    {ticket.ticketType === 1 ? "Operational" : "Technical"}
                                </p>
                            </div>
                        </Grid>
                    ))}

            </Grid>

            <Modal
                open={openModal}
                onClose={handleCloseModal}
                closeAfterTransition
                sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
            >
                <Fade in={openModal}>
                    <div
                        style={{
                            background: "#1e1e1e",
                            color: "white",
                            width: "480px",
                            borderRadius: "15px",
                            padding: "25px",
                            boxShadow: "0 0 30px rgba(0,0,0,0.7)",
                            border: "1px solid #444",
                            position: "relative"
                        }}
                    >
                        {/* Close Button */}
                        <button
                            onClick={handleCloseModal}
                            style={{
                                position: "absolute",
                                top: "12px",
                                right: "12px",
                                background: "transparent",
                                border: "none",
                                color: "#ccc",
                                fontSize: "18px",
                                cursor: "pointer",
                                transition: "0.2s"
                            }}
                            onMouseOver={(e) => (e.currentTarget.style.color = "#fff")}
                            onMouseOut={(e) => (e.currentTarget.style.color = "#ccc")}
                        >
                            ✕
                        </button>

                        {/* Modal Title */}
                        <h2 style={{ marginBottom: "20px", textAlign: "center" }}>
                            Ticket Details
                        </h2>

                        {selectedTicket && (
                            <>
                                <p style={{ marginBottom: "8px" }}>
                                    <strong>Title:</strong> {selectedTicket.title}
                                </p>

                                <p style={{ marginBottom: "8px" }}>
                                    <strong>Type:</strong>{" "}
                                    {selectedTicket.ticketType === 1 ? "Operational" : "Technical"}
                                </p>

                                <p style={{ marginBottom: "8px" }}>
                                    <strong>Description:</strong><br />
                                    {selectedTicket.description}
                                </p>

                                <p style={{ marginBottom: "8px", opacity: 0.8 }}>
                                    <strong>Submitted On:</strong><br />
                                    {selectedTicket.lastSyncedTime.split("T")[0] + " " + selectedTicket.lastSyncedTime.split("T")[1].split(".")[0]}
                                </p>

                                <p style={{ marginBottom: "15px", opacity: 0.8 }}>
                                    <strong>Status:</strong>{" "}
                                    {selectedTicket.isAddressed ? "Completed" : "Pending"}
                                </p>
                            </>
                        )}
                    </div>
                </Fade>
            </Modal>


        </div>
    );
}
